import * as Sentry from '@sentry/angular';
import { environment } from '$env/environment';
import { ApplicationRef, enableProdMode } from '@angular/core';
import { enableDebugTools } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'hammerjs';
import { AppModule } from './app/app.module';
import '@belpost-web/contacts-kit/browser/main.js';
import '@belpost-web/checkout-kit/browser/main.js';
import '@belpost-web/individual-epa-kit/browser/main.js';
import '@belpost-web/map-kit';

if (
  environment.sentry &&
  environment.sentry.enabled &&
  environment.sentry.dsn
) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.name,
    enableLogs: true,
    sendDefaultPii: true,
  });
}

if (environment.production) {
  enableProdMode();
}

const bootstrap = () =>
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then((module) => {
      if (!environment.production) {
        const applicationRef = module.injector.get(ApplicationRef);
        const appComponent = applicationRef.components[0];
        enableDebugTools(appComponent);
      }
      return module;
    });

bootstrap().catch((err) => console.error(err));
